import { StrictMode } from 'react'

import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
// import { ToastContainer } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

import { RouterRoot } from 'modules/router/ui/RouterRoot'
import { ThemeProvider } from 'modules/themes/ThemeProvider'
import { ScrollRestorator } from 'shared/ui/utils/ScrollRestorator'

import { initSentry } from 'modules/analytics/sentry'
import { initGleap } from 'modules/analytics/gleap'
import { initHotjar } from 'modules/analytics/hotjar'

import 'modules/appRoot/fonts.scss'
import 'modules/appRoot/global-styles.scss'

import 'gleap/build/index.min.css'

import { BASE_URL } from 'config'

const history = createBrowserHistory()

initHotjar()
initGleap()
initSentry(history)

export function AppRoot() {
  return (
    <StrictMode>
      <ThemeProvider>
        <BrowserRouter basename={BASE_URL}>
          <ScrollRestorator />
          {/* <ToastContainer /> */}
          <RouterRoot />
        </BrowserRouter>
      </ThemeProvider>
    </StrictMode>
  )
}
